import { Dispatch } from '@reduxjs/toolkit';
import axiosInstance, { ApiKeys, getApiUrl, logError } from '../../utils/ApiHelper';
import { setAgencies, setStates } from '../../reducers/agencyPincodeMappingSllice';

export const fetchFiltersData = (setLoader: (loading: boolean) => void) => (dispatch: Dispatch) => {
  const reportingAgenciesUrl = getApiUrl(ApiKeys.GET_ALL_REPORTING_AGENCIES);
  const statesUrl = getApiUrl(ApiKeys.GET_ALL_SERVICEABLILITY_STATES);

  const agenciesPromise = axiosInstance
    .get(reportingAgenciesUrl)
    .then(response => response.data)
    .catch(err => logError(err));

  const statesPromise = axiosInstance
    .get(statesUrl)
    .then(response => response.data)
    .catch(err => logError(err));

  Promise.all([statesPromise, agenciesPromise])
    .then(res => {
      dispatch(setAgencies(res[1]));
      dispatch(setStates(res[0]));
    })
    .finally(() => {
      setLoader(false);
    });
};
